module.exports = __webpack_public_path__ + "media/images/emoticons/ear-1a1fc6f04b39471617c37182c4d29131.gif";